// import { win, disableScroll, enableScroll } from '../utils'
// import gsap from 'gsap';

export const Header = new function() {
    let items;
    let component;
    const activeItemClass = 'current-menu-item';
 
    this.init = () => {
        component = document.querySelector('header.tl-header')
        if(!component) return
        
        items = component.querySelectorAll('.menu-item > a')
        items.forEach( menuItem => {
            const text = menuItem.textContent;
            menuItem.textContent = '';
            const spanBefore = document.createElement('span');
            spanBefore.textContent = text;
            spanBefore.classList.add('menu-item-text-normal');
            menuItem.appendChild(spanBefore);
            const spanAfter = document.createElement('span');
            spanAfter.textContent = text;
            spanAfter.classList.add('menu-item-text-abs');
            menuItem.appendChild(spanAfter);
            
            menuItem.addEventListener( 'click', (e) => {
                items.forEach( it => {
                    it.parentElement.classList.remove(activeItemClass);
                });
                menuItem.parentElement.classList.add(activeItemClass);
            });
        });

        // window.addEventListener('resize', () => {
        //     this.close()
        // })
    }

}